import { useRoute } from '#imports'
import type { RouteParamValue } from 'vue-router'

/**
 * Composable to retrieve the current URL query with the right typings and failsafe.
 * vue-router returns query as LocationQuery (Record<string, LocationQueryValue | LocationQueryValue[]>
 * we'll mostly want it as a Record<string, string>
 *
 * @example
 * To retrieve the model query value
 * ```
 * const { model } = useRouteQuery()
 * ```
 */

export function useRouteQuery(): Record<string, RouteParamValue> {
  const { query } = useRoute()

  return Object.entries(query).reduce(
    (acc, [key, value]) => {
      const stringValue = Array.isArray(value) ? value.join(',') : String(value)

      return { ...acc, [key]: stringValue }
    },
    {} as Record<string, string>,
  )
}
